/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DropDownItem } from "../models/drop-down-item";
import { Interacts } from "../models/interacts";
import { Interact } from "../models/interact";
import { ModifiedInteract } from "../models/modified-interact";
import { UpdateSharingStatus } from "../models/update-sharing-status";
import { InteractiveFilter } from "../models/interactive-filter";
import { UdInteractFilters } from "../models/ud-interact-filters";
import { InteractiveBookmark } from "../models/interactive-bookmark";
import { UdInteractBookmarks } from "../models/ud-interact-bookmarks";
import { InteractReportsEx } from "../models/interact-reports-ex";
import { SubInteractReportExportsEx } from "../models/sub-interact-report-exports-ex";
import { ReportExportDetails } from "../models/report-export-details";
import { SubInteractReportExports } from "../models/sub-interact-report-exports";
import { PartnerEmbedDetails } from "../models/partner-embed-details";
import { ReportPageDefinition } from "../models/report-page-definition";
@Injectable({
  providedIn: "root",
})
class InteractivesService extends __BaseService {
  static readonly interactivesGetInteractivesListPath =
    "/api/Interactives/GetInteractivesList";
  static readonly interactivesGetInteractivesList2Path =
    "/api/Interactives/GetInteractivesListBySubscriptionId";
  static readonly interactivesGetInteractiveByIdPath =
    "/api/Interactives/GetInteractiveById";
  static readonly interactivesGetModifiedInteractiveByIdPath =
    "/api/Interactives/GetModifiedInteractiveById";
  static readonly interactivesGetInteractiveActionOptionsPath =
    "/api/Interactives/GetInteractiveActionOptions";
  static readonly interactivesDuplicateInteractivePath =
    "/api/Interactives/DuplicateInteractive";
  static readonly interactivesDeleteInteractivePath =
    "/api/Interactives/DeleteInteractive";
  static readonly interactivesUpdateInteractiveSharingPath =
    "/api/Interactives/UpdateInteractiveSharing";
  static readonly interactivesUpdateInteractiveNamePath =
    "/api/Interactives/UpdateInteractiveName";
  static readonly interactivesGetInteractiveFilterOptionsPath =
    "/api/Interactives/GetInteractiveFilterOptions";
  static readonly interactivesGetInteractiveFiltersPath =
    "/api/Interactives/GetInteractiveFilters";
  static readonly interactivesSaveInteractiveFilterPath =
    "/api/Interactives/SaveInteractiveFilter";
  static readonly interactivesUpdateFilterSharingPath =
    "/api/Interactives/UpdateFilterSharing";
  static readonly interactivesDeleteInteractiveFilterPath =
    "/api/Interactives/DeleteInteractiveFilter";
  static readonly interactivesGetInteractiveBookmarkOptionsPath =
    "/api/Interactives/GetInteractiveBookmarkOptions";
  static readonly interactivesGetInteractiveBookmarksPath =
    "/api/Interactives/GetInteractiveBookmarks";
  static readonly interactivesSaveInteractiveBookmarkPath =
    "/api/Interactives/SaveInteractiveBookmark";
  static readonly interactivesUpdateBookmarkSharingPath =
    "/api/Interactives/UpdateBookmarkSharing";
  static readonly interactivesDeleteInteractiveBookmarkPath =
    "/api/Interactives/DeleteInteractiveBookmark";
  static readonly interactivesGetReportsPath = "/api/Interactives/GetReports";
  static readonly interactivesGetReportExportsByInteractivePath =
    "/api/Interactives/GetReportExportsByInteractive";
  static readonly interactivesGetReportExportsBySubscriptionPath =
    "/api/Interactives/GetReportExportsBySubscription";
  static readonly interactivesExportReportInteractivePath =
    "/api/Interactives/ExportReportInteractive";
  static readonly interactivesUpdateReportSharingPath =
    "/api/Interactives/UpdateReportSharing";
  static readonly interactivesGetReportExportPath =
    "/api/Interactives/GetReportExport";
  static readonly interactivesSetReportExportPageCompletePath =
    "/api/Interactives/SetReportPageComplete";
  static readonly interactivesGetReportExportDownloadUrlPath =
    "/api/Interactives/GetReportExportDownloadUrl";
  static readonly interactivesGetReportExportStatusPath =
    "/api/Interactives/GetReportExportStatus";
  static readonly interactivesDeleteReportExportPath =
    "/api/Interactives/DeleteReportExport";
  static readonly interactivesGetPartnerEmbedDetailsPath =
    "/api/Interactives/GetPartnerEmbedDetails";
  static readonly interactivesGetInteractivePagesPath =
    "/api/Interactives/GetInteractivePages";
  static readonly interactivesLogNavigatedToInteractivePagePath =
    "/api/Interactives/Log_NavigatedToInteractivePage";
  static readonly interactivesLogAppliedBookmarkPath =
    "/api/Interactives/Log_AppliedBookmark";
  static readonly interactivesLogAppliedFilterPath =
    "/api/Interactives/Log_AppliedFilter";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  interactivesGetInteractivesListResponse(): __Observable<
    __StrictHttpResponse<Array<DropDownItem>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractivesList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DropDownItem>>;
      })
    );
  }
  interactivesGetInteractivesList(): __Observable<Array<DropDownItem>> {
    return this.interactivesGetInteractivesListResponse().pipe(
      __map((_r) => _r.body as Array<DropDownItem>)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  interactivesGetInteractivesList2Response(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<Interacts>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractivesListBySubscriptionId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Interacts>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  interactivesGetInteractivesList2(
    subscriptionId?: number
  ): __Observable<Array<Interacts>> {
    return this.interactivesGetInteractivesList2Response(subscriptionId).pipe(
      __map((_r) => _r.body as Array<Interacts>)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesGetInteractiveByIdParams` containing the following parameters:
   *
   * - `versionId`:
   *
   * - `revisionId`:
   *
   * - `interactiveId`:
   */
  interactivesGetInteractiveByIdResponse(
    params: InteractivesService.InteractivesGetInteractiveByIdParams
  ): __Observable<__StrictHttpResponse<Interact>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.versionId != null)
      __params = __params.set("versionId", params.versionId.toString());
    if (params.revisionId != null)
      __params = __params.set("revisionId", params.revisionId.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractiveById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Interact>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesGetInteractiveByIdParams` containing the following parameters:
   *
   * - `versionId`:
   *
   * - `revisionId`:
   *
   * - `interactiveId`:
   */
  interactivesGetInteractiveById(
    params: InteractivesService.InteractivesGetInteractiveByIdParams
  ): __Observable<Interact> {
    return this.interactivesGetInteractiveByIdResponse(params).pipe(
      __map((_r) => _r.body as Interact)
    );
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetModifiedInteractiveByIdResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<ModifiedInteract>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetModifiedInteractiveById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ModifiedInteract>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetModifiedInteractiveById(
    interactiveId?: number
  ): __Observable<ModifiedInteract> {
    return this.interactivesGetModifiedInteractiveByIdResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as ModifiedInteract));
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveActionOptionsResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<DropDownItem>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractiveActionOptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DropDownItem>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveActionOptions(
    interactiveId?: number
  ): __Observable<Array<DropDownItem>> {
    return this.interactivesGetInteractiveActionOptionsResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<DropDownItem>));
  }

  /**
   * @param params The `InteractivesService.InteractivesDuplicateInteractiveParams` containing the following parameters:
   *
   * - `newName`:
   *
   * - `interactiveId`:
   */
  interactivesDuplicateInteractiveResponse(
    params: InteractivesService.InteractivesDuplicateInteractiveParams
  ): __Observable<__StrictHttpResponse<DropDownItem>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.newName != null)
      __params = __params.set("newName", params.newName.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/DuplicateInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DropDownItem>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesDuplicateInteractiveParams` containing the following parameters:
   *
   * - `newName`:
   *
   * - `interactiveId`:
   */
  interactivesDuplicateInteractive(
    params: InteractivesService.InteractivesDuplicateInteractiveParams
  ): __Observable<DropDownItem> {
    return this.interactivesDuplicateInteractiveResponse(params).pipe(
      __map((_r) => _r.body as DropDownItem)
    );
  }

  /**
   * @param interactiveId undefined
   */
  interactivesDeleteInteractiveResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/DeleteInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesDeleteInteractive(interactiveId?: number): __Observable<boolean> {
    return this.interactivesDeleteInteractiveResponse(interactiveId).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesUpdateInteractiveSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `interactiveId`:
   */
  interactivesUpdateInteractiveSharingResponse(
    params: InteractivesService.InteractivesUpdateInteractiveSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/UpdateInteractiveSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesUpdateInteractiveSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `interactiveId`:
   */
  interactivesUpdateInteractiveSharing(
    params: InteractivesService.InteractivesUpdateInteractiveSharingParams
  ): __Observable<boolean> {
    return this.interactivesUpdateInteractiveSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesUpdateInteractiveNameParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `newName`:
   *
   * - `interactiveId`:
   */
  interactivesUpdateInteractiveNameResponse(
    params: InteractivesService.InteractivesUpdateInteractiveNameParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.newName != null)
      __params = __params.set("newName", params.newName.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/UpdateInteractiveName`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesUpdateInteractiveNameParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `newName`:
   *
   * - `interactiveId`:
   */
  interactivesUpdateInteractiveName(
    params: InteractivesService.InteractivesUpdateInteractiveNameParams
  ): __Observable<boolean> {
    return this.interactivesUpdateInteractiveNameResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveFilterOptionsResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<DropDownItem>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractiveFilterOptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DropDownItem>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveFilterOptions(
    interactiveId?: number
  ): __Observable<Array<DropDownItem>> {
    return this.interactivesGetInteractiveFilterOptionsResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<DropDownItem>));
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveFiltersResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<InteractiveFilter>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractiveFilters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractiveFilter>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveFilters(
    interactiveId?: number
  ): __Observable<Array<InteractiveFilter>> {
    return this.interactivesGetInteractiveFiltersResponse(interactiveId).pipe(
      __map((_r) => _r.body as Array<InteractiveFilter>)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesSaveInteractiveFilterParams` containing the following parameters:
   *
   * - `filter`:
   *
   * - `userId`:
   */
  interactivesSaveInteractiveFilterResponse(
    params: InteractivesService.InteractivesSaveInteractiveFilterParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.filter;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/SaveInteractiveFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesSaveInteractiveFilterParams` containing the following parameters:
   *
   * - `filter`:
   *
   * - `userId`:
   */
  interactivesSaveInteractiveFilter(
    params: InteractivesService.InteractivesSaveInteractiveFilterParams
  ): __Observable<number> {
    return this.interactivesSaveInteractiveFilterResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesUpdateFilterSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `filterId`:
   */
  interactivesUpdateFilterSharingResponse(
    params: InteractivesService.InteractivesUpdateFilterSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.filterId != null)
      __params = __params.set("filterId", params.filterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/UpdateFilterSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesUpdateFilterSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `filterId`:
   */
  interactivesUpdateFilterSharing(
    params: InteractivesService.InteractivesUpdateFilterSharingParams
  ): __Observable<boolean> {
    return this.interactivesUpdateFilterSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesDeleteInteractiveFilterParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `filterId`:
   */
  interactivesDeleteInteractiveFilterResponse(
    params: InteractivesService.InteractivesDeleteInteractiveFilterParams
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.filterId != null)
      __params = __params.set("filterId", params.filterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/DeleteInteractiveFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesDeleteInteractiveFilterParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `filterId`:
   */
  interactivesDeleteInteractiveFilter(
    params: InteractivesService.InteractivesDeleteInteractiveFilterParams
  ): __Observable<string> {
    return this.interactivesDeleteInteractiveFilterResponse(params).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveBookmarkOptionsResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<DropDownItem>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractiveBookmarkOptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DropDownItem>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveBookmarkOptions(
    interactiveId?: number
  ): __Observable<Array<DropDownItem>> {
    return this.interactivesGetInteractiveBookmarkOptionsResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<DropDownItem>));
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveBookmarksResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<InteractiveBookmark>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractiveBookmarks`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractiveBookmark>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractiveBookmarks(
    interactiveId?: number
  ): __Observable<Array<InteractiveBookmark>> {
    return this.interactivesGetInteractiveBookmarksResponse(interactiveId).pipe(
      __map((_r) => _r.body as Array<InteractiveBookmark>)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesSaveInteractiveBookmarkParams` containing the following parameters:
   *
   * - `bookmark`:
   *
   * - `userId`:
   */
  interactivesSaveInteractiveBookmarkResponse(
    params: InteractivesService.InteractivesSaveInteractiveBookmarkParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.bookmark;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/SaveInteractiveBookmark`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesSaveInteractiveBookmarkParams` containing the following parameters:
   *
   * - `bookmark`:
   *
   * - `userId`:
   */
  interactivesSaveInteractiveBookmark(
    params: InteractivesService.InteractivesSaveInteractiveBookmarkParams
  ): __Observable<number> {
    return this.interactivesSaveInteractiveBookmarkResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesUpdateBookmarkSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `bookmarkId`:
   */
  interactivesUpdateBookmarkSharingResponse(
    params: InteractivesService.InteractivesUpdateBookmarkSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.bookmarkId != null)
      __params = __params.set("bookmarkId", params.bookmarkId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/UpdateBookmarkSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesUpdateBookmarkSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `bookmarkId`:
   */
  interactivesUpdateBookmarkSharing(
    params: InteractivesService.InteractivesUpdateBookmarkSharingParams
  ): __Observable<boolean> {
    return this.interactivesUpdateBookmarkSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesDeleteInteractiveBookmarkParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `bookmarkId`:
   */
  interactivesDeleteInteractiveBookmarkResponse(
    params: InteractivesService.InteractivesDeleteInteractiveBookmarkParams
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.bookmarkId != null)
      __params = __params.set("bookmarkId", params.bookmarkId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/DeleteInteractiveBookmark`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesDeleteInteractiveBookmarkParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `bookmarkId`:
   */
  interactivesDeleteInteractiveBookmark(
    params: InteractivesService.InteractivesDeleteInteractiveBookmarkParams
  ): __Observable<string> {
    return this.interactivesDeleteInteractiveBookmarkResponse(params).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param interactId undefined
   */
  interactivesGetReportsResponse(
    interactId?: number
  ): __Observable<__StrictHttpResponse<Array<InteractReportsEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactId != null)
      __params = __params.set("interactId", interactId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/GetReports`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractReportsEx>>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  interactivesGetReports(
    interactId?: number
  ): __Observable<Array<InteractReportsEx>> {
    return this.interactivesGetReportsResponse(interactId).pipe(
      __map((_r) => _r.body as Array<InteractReportsEx>)
    );
  }

  /**
   * @param interactId undefined
   */
  interactivesGetReportExportsByInteractiveResponse(
    interactId?: number
  ): __Observable<__StrictHttpResponse<Array<SubInteractReportExportsEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactId != null)
      __params = __params.set("interactId", interactId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/GetReportExportsByInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubInteractReportExportsEx>>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  interactivesGetReportExportsByInteractive(
    interactId?: number
  ): __Observable<Array<SubInteractReportExportsEx>> {
    return this.interactivesGetReportExportsByInteractiveResponse(
      interactId
    ).pipe(__map((_r) => _r.body as Array<SubInteractReportExportsEx>));
  }

  /**
   * @param subscriptionId undefined
   */
  interactivesGetReportExportsBySubscriptionResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<SubInteractReportExportsEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/GetReportExportsBySubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubInteractReportExportsEx>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  interactivesGetReportExportsBySubscription(
    subscriptionId?: number
  ): __Observable<Array<SubInteractReportExportsEx>> {
    return this.interactivesGetReportExportsBySubscriptionResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as Array<SubInteractReportExportsEx>));
  }

  /**
   * @param exportDetails undefined
   */
  interactivesExportReportInteractiveResponse(
    exportDetails: ReportExportDetails
  ): __Observable<__StrictHttpResponse<SubInteractReportExportsEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = exportDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/ExportReportInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubInteractReportExportsEx>;
      })
    );
  }
  /**
   * @param exportDetails undefined
   */
  interactivesExportReportInteractive(
    exportDetails: ReportExportDetails
  ): __Observable<SubInteractReportExportsEx> {
    return this.interactivesExportReportInteractiveResponse(exportDetails).pipe(
      __map((_r) => _r.body as SubInteractReportExportsEx)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesUpdateReportSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `SubInteractReportExportId`:
   */
  interactivesUpdateReportSharingResponse(
    params: InteractivesService.InteractivesUpdateReportSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.SubInteractReportExportId != null)
      __params = __params.set(
        "SubInteractReportExportId",
        params.SubInteractReportExportId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/UpdateReportSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesUpdateReportSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `SubInteractReportExportId`:
   */
  interactivesUpdateReportSharing(
    params: InteractivesService.InteractivesUpdateReportSharingParams
  ): __Observable<boolean> {
    return this.interactivesUpdateReportSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesGetReportExportParams` containing the following parameters:
   *
   * - `reportExportId`:
   *
   * - `interactiveId`:
   */
  interactivesGetReportExportResponse(
    params: InteractivesService.InteractivesGetReportExportParams
  ): __Observable<__StrictHttpResponse<SubInteractReportExports>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportExportId != null)
      __params = __params.set(
        "reportExportId",
        params.reportExportId.toString()
      );
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetReportExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubInteractReportExports>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesGetReportExportParams` containing the following parameters:
   *
   * - `reportExportId`:
   *
   * - `interactiveId`:
   */
  interactivesGetReportExport(
    params: InteractivesService.InteractivesGetReportExportParams
  ): __Observable<SubInteractReportExports> {
    return this.interactivesGetReportExportResponse(params).pipe(
      __map((_r) => _r.body as SubInteractReportExports)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesSetReportExportPageCompleteParams` containing the following parameters:
   *
   * - `reportExportId`:
   *
   * - `interactiveId`:
   *
   * - `completedPage`:
   */
  interactivesSetReportExportPageCompleteResponse(
    params: InteractivesService.InteractivesSetReportExportPageCompleteParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportExportId != null)
      __params = __params.set(
        "reportExportId",
        params.reportExportId.toString()
      );
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    if (params.completedPage != null)
      __params = __params.set("completedPage", params.completedPage.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/SetReportPageComplete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesSetReportExportPageCompleteParams` containing the following parameters:
   *
   * - `reportExportId`:
   *
   * - `interactiveId`:
   *
   * - `completedPage`:
   */
  interactivesSetReportExportPageComplete(
    params: InteractivesService.InteractivesSetReportExportPageCompleteParams
  ): __Observable<boolean> {
    return this.interactivesSetReportExportPageCompleteResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param subInteractReportExportId undefined
   */
  interactivesGetReportExportDownloadUrlResponse(
    subInteractReportExportId?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subInteractReportExportId != null)
      __params = __params.set(
        "subInteractReportExportId",
        subInteractReportExportId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetReportExportDownloadUrl`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param subInteractReportExportId undefined
   */
  interactivesGetReportExportDownloadUrl(
    subInteractReportExportId?: number
  ): __Observable<string> {
    return this.interactivesGetReportExportDownloadUrlResponse(
      subInteractReportExportId
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param subInteractReportExportId undefined
   */
  interactivesGetReportExportStatusResponse(
    subInteractReportExportId?: number
  ): __Observable<__StrictHttpResponse<SubInteractReportExportsEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subInteractReportExportId != null)
      __params = __params.set(
        "subInteractReportExportId",
        subInteractReportExportId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetReportExportStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubInteractReportExportsEx>;
      })
    );
  }
  /**
   * @param subInteractReportExportId undefined
   */
  interactivesGetReportExportStatus(
    subInteractReportExportId?: number
  ): __Observable<SubInteractReportExportsEx> {
    return this.interactivesGetReportExportStatusResponse(
      subInteractReportExportId
    ).pipe(__map((_r) => _r.body as SubInteractReportExportsEx));
  }

  /**
   * @param params The `InteractivesService.InteractivesDeleteReportExportParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `subInteractReportExportId`:
   */
  interactivesDeleteReportExportResponse(
    params: InteractivesService.InteractivesDeleteReportExportParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.subInteractReportExportId != null)
      __params = __params.set(
        "subInteractReportExportId",
        params.subInteractReportExportId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/DeleteReportExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesDeleteReportExportParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `subInteractReportExportId`:
   */
  interactivesDeleteReportExport(
    params: InteractivesService.InteractivesDeleteReportExportParams
  ): __Observable<boolean> {
    return this.interactivesDeleteReportExportResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param partnerKey undefined
   */
  interactivesGetPartnerEmbedDetailsResponse(
    partnerKey?: string
  ): __Observable<__StrictHttpResponse<PartnerEmbedDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerKey != null)
      __params = __params.set("partnerKey", partnerKey.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetPartnerEmbedDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PartnerEmbedDetails>;
      })
    );
  }
  /**
   * @param partnerKey undefined
   */
  interactivesGetPartnerEmbedDetails(
    partnerKey?: string
  ): __Observable<PartnerEmbedDetails> {
    return this.interactivesGetPartnerEmbedDetailsResponse(partnerKey).pipe(
      __map((_r) => _r.body as PartnerEmbedDetails)
    );
  }

  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractivePagesResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportPageDefinition>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Interactives/GetInteractivePages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportPageDefinition>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  interactivesGetInteractivePages(
    interactiveId?: number
  ): __Observable<Array<ReportPageDefinition>> {
    return this.interactivesGetInteractivePagesResponse(interactiveId).pipe(
      __map((_r) => _r.body as Array<ReportPageDefinition>)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesLogNavigatedToInteractivePageParams` containing the following parameters:
   *
   * - `preFilteredInteractiveId`:
   *
   * - `modifiedInteractiveId`:
   *
   * - `interactivePage`:
   *
   * - `interactiveId`:
   */
  interactivesLogNavigatedToInteractivePageResponse(
    params: InteractivesService.InteractivesLogNavigatedToInteractivePageParams
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilteredInteractiveId != null)
      __params = __params.set(
        "preFilteredInteractiveId",
        params.preFilteredInteractiveId.toString()
      );
    if (params.modifiedInteractiveId != null)
      __params = __params.set(
        "modifiedInteractiveId",
        params.modifiedInteractiveId.toString()
      );
    if (params.interactivePage != null)
      __params = __params.set(
        "interactivePage",
        params.interactivePage.toString()
      );
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/Log_NavigatedToInteractivePage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesLogNavigatedToInteractivePageParams` containing the following parameters:
   *
   * - `preFilteredInteractiveId`:
   *
   * - `modifiedInteractiveId`:
   *
   * - `interactivePage`:
   *
   * - `interactiveId`:
   */
  interactivesLogNavigatedToInteractivePage(
    params: InteractivesService.InteractivesLogNavigatedToInteractivePageParams
  ): __Observable<null> {
    return this.interactivesLogNavigatedToInteractivePageResponse(params).pipe(
      __map((_r) => _r.body as null)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesLogAppliedBookmarkParams` containing the following parameters:
   *
   * - `preFilteredInteractiveId`:
   *
   * - `modifiedInteractiveId`:
   *
   * - `interactiveId`:
   *
   * - `bookmarkId`:
   */
  interactivesLogAppliedBookmarkResponse(
    params: InteractivesService.InteractivesLogAppliedBookmarkParams
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilteredInteractiveId != null)
      __params = __params.set(
        "preFilteredInteractiveId",
        params.preFilteredInteractiveId.toString()
      );
    if (params.modifiedInteractiveId != null)
      __params = __params.set(
        "modifiedInteractiveId",
        params.modifiedInteractiveId.toString()
      );
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    if (params.bookmarkId != null)
      __params = __params.set("bookmarkId", params.bookmarkId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/Log_AppliedBookmark`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesLogAppliedBookmarkParams` containing the following parameters:
   *
   * - `preFilteredInteractiveId`:
   *
   * - `modifiedInteractiveId`:
   *
   * - `interactiveId`:
   *
   * - `bookmarkId`:
   */
  interactivesLogAppliedBookmark(
    params: InteractivesService.InteractivesLogAppliedBookmarkParams
  ): __Observable<null> {
    return this.interactivesLogAppliedBookmarkResponse(params).pipe(
      __map((_r) => _r.body as null)
    );
  }

  /**
   * @param params The `InteractivesService.InteractivesLogAppliedFilterParams` containing the following parameters:
   *
   * - `preFilteredInteractiveId`:
   *
   * - `modifiedInteractiveId`:
   *
   * - `interactiveId`:
   *
   * - `filterId`:
   */
  interactivesLogAppliedFilterResponse(
    params: InteractivesService.InteractivesLogAppliedFilterParams
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilteredInteractiveId != null)
      __params = __params.set(
        "preFilteredInteractiveId",
        params.preFilteredInteractiveId.toString()
      );
    if (params.modifiedInteractiveId != null)
      __params = __params.set(
        "modifiedInteractiveId",
        params.modifiedInteractiveId.toString()
      );
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    if (params.filterId != null)
      __params = __params.set("filterId", params.filterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Interactives/Log_AppliedFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `InteractivesService.InteractivesLogAppliedFilterParams` containing the following parameters:
   *
   * - `preFilteredInteractiveId`:
   *
   * - `modifiedInteractiveId`:
   *
   * - `interactiveId`:
   *
   * - `filterId`:
   */
  interactivesLogAppliedFilter(
    params: InteractivesService.InteractivesLogAppliedFilterParams
  ): __Observable<null> {
    return this.interactivesLogAppliedFilterResponse(params).pipe(
      __map((_r) => _r.body as null)
    );
  }
}

module InteractivesService {
  /**
   * Parameters for InteractivesGetInteractiveById
   */
  export interface InteractivesGetInteractiveByIdParams {
    versionId?: number;
    revisionId?: number;
    interactiveId?: number;
  }

  /**
   * Parameters for InteractivesDuplicateInteractive
   */
  export interface InteractivesDuplicateInteractiveParams {
    newName?: null | string;
    interactiveId?: number;
  }

  /**
   * Parameters for InteractivesUpdateInteractiveSharing
   */
  export interface InteractivesUpdateInteractiveSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    interactiveId?: number;
  }

  /**
   * Parameters for InteractivesUpdateInteractiveName
   */
  export interface InteractivesUpdateInteractiveNameParams {
    userId?: number;
    newName?: null | string;
    interactiveId?: number;
  }

  /**
   * Parameters for InteractivesSaveInteractiveFilter
   */
  export interface InteractivesSaveInteractiveFilterParams {
    filter: UdInteractFilters;
    userId?: number;
  }

  /**
   * Parameters for InteractivesUpdateFilterSharing
   */
  export interface InteractivesUpdateFilterSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    filterId?: number;
  }

  /**
   * Parameters for InteractivesDeleteInteractiveFilter
   */
  export interface InteractivesDeleteInteractiveFilterParams {
    userId?: number;
    filterId?: number;
  }

  /**
   * Parameters for InteractivesSaveInteractiveBookmark
   */
  export interface InteractivesSaveInteractiveBookmarkParams {
    bookmark: UdInteractBookmarks;
    userId?: number;
  }

  /**
   * Parameters for InteractivesUpdateBookmarkSharing
   */
  export interface InteractivesUpdateBookmarkSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    bookmarkId?: number;
  }

  /**
   * Parameters for InteractivesDeleteInteractiveBookmark
   */
  export interface InteractivesDeleteInteractiveBookmarkParams {
    userId?: number;
    bookmarkId?: number;
  }

  /**
   * Parameters for InteractivesUpdateReportSharing
   */
  export interface InteractivesUpdateReportSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    SubInteractReportExportId?: number;
  }

  /**
   * Parameters for InteractivesGetReportExport
   */
  export interface InteractivesGetReportExportParams {
    reportExportId?: number;
    interactiveId?: number;
  }

  /**
   * Parameters for InteractivesSetReportExportPageComplete
   */
  export interface InteractivesSetReportExportPageCompleteParams {
    reportExportId?: number;
    interactiveId?: number;
    completedPage?: null | string;
  }

  /**
   * Parameters for InteractivesDeleteReportExport
   */
  export interface InteractivesDeleteReportExportParams {
    userId?: number;
    subInteractReportExportId?: number;
  }

  /**
   * Parameters for InteractivesLogNavigatedToInteractivePage
   */
  export interface InteractivesLogNavigatedToInteractivePageParams {
    preFilteredInteractiveId?: null | number;
    modifiedInteractiveId?: null | number;
    interactivePage?: null | string;
    interactiveId?: null | number;
  }

  /**
   * Parameters for InteractivesLogAppliedBookmark
   */
  export interface InteractivesLogAppliedBookmarkParams {
    preFilteredInteractiveId?: null | number;
    modifiedInteractiveId?: null | number;
    interactiveId?: null | number;
    bookmarkId?: number;
  }

  /**
   * Parameters for InteractivesLogAppliedFilter
   */
  export interface InteractivesLogAppliedFilterParams {
    preFilteredInteractiveId?: null | number;
    modifiedInteractiveId?: null | number;
    interactiveId?: null | number;
    filterId?: number;
  }
}

export { InteractivesService };
